<div *ngIf="layerItem" class="layer-item">

	<div class="layer-label">
		{{layerItem.label}}
	</div>
	<!-- <div *ngIf="layerItem.selectOptions" class="layer-select-options">
		<div *ngFor="let op of layerItem.selectOptions" class="item-option">
			<input type="radio" name="selectOptions" [value]="op" [(ngModel)]="selectedItem" (ngModelChange)="onSelectItem()">
			<label>{{op.label}}</label>
		</div>
	</div> -->
	<div class="layer-select-options">
		<select *ngIf="layerItem.selectOptions" name="layer-option" [(ngModel)]="selectedItem" (ngModelChange)="onSelectItem()">
			<option *ngFor="let op of layerItem.selectOptions" [ngValue]="op">{{op.label}}</option>
		</select>
	</div>
	<div *ngIf="layerItem.opacitySlider" class="layer-slider-option">
		<div class="layer-opacity" title="Layer Opacity">
			<mat-slider #opacitySlider class="layer-opacity-slider" min="0" max="1" step="0.1" tickInterval="2" [(ngModel)]="layerOpacity" (ngModelChange)="onOpacitySliderDragEnd();opacitySlider.blur();">
			</mat-slider>
		</div>
	</div>
	<div *ngIf="layerItem.hasToggle" class="layer-toggle">
		<input type="checkbox" name="is-on" [(ngModel)]="layerItem.isOn" (ngModelChange)="onToggleLayer()">
	</div>

	<!-- <div class="layer-color">

	</div>
	<div class="layer-transparency">
		<mat-slider min="0" max="100" [value]="layerItem.transparency" style="width:100%;">
		</mat-slider>
	</div> -->
</div>
